import * as types from 'constants/ActionTypes';
import { Map } from 'immutable';

const defaultState = Map({
  user: null,
  isUserLoading: false,
  isUserFetched: false,
  isUserAnonymous: false,
  nextPurchase: null,
  isNextPurchaseLoading: false,
  isNextPurchaseFetched: false,
  connectedAccounts: [],
  isConnectedAccountsLoading: false,
  isConnectedAccountsFetched: false,
  wallets: [],
  isWalletsLoading: false,
  isWalletsFetched: false,
  showDotersUnavailableDialog: false,
});

/**
 * Reducer for Reserhub account state
 * @param {Object} state - Current state
 * @param {Object} action - Action to process
 * @returns {Object} New state
 */
export default function reserhubAccount(state = defaultState, action) {
  switch (action.type) {
    case types.SET_RESERHUB_USER_LOADING:
      return action.isLoading
        ? state.set('isUserLoading', true).set('isUserAnonymous', false)
        : state.set('isUserLoading', false).set('isUserFetched', true);
    case types.SET_RESERHUB_USER:
      return state
        .set('user', action.user)
        .set('isUserLoading', false)
        .set('isUserFetched', true)
        .set('isUserAnonymous', Boolean(action.isAnonymous));
    case types.CLEAR_RESERHUB_USER:
      return state
        .set('user', null)
        .set('isUserLoading', false)
        .set('isUserFetched', action.isAnonymous !== false)
        .set('isUserAnonymous', action.isAnonymous !== false);
    case types.SET_RESERHUB_NEXT_PURCHASE_LOADING:
      return state
        .set('isNextPurchaseLoading', action.isLoading)
        .set('isNextPurchaseFetched', !action.isLoading);
    case types.SET_RESERHUB_NEXT_PURCHASE:
      return state
        .set('nextPurchase', action.nextPurchase)
        .set('isNextPurchaseLoading', false)
        .set('isNextPurchaseFetched', true);
    case types.CLEAR_RESERHUB_NEXT_PURCHASE:
      return state
        .set('nextPurchase', null)
        .set('isNextPurchaseLoading', false)
        .set('isNextPurchaseFetched', true);
    // Distinct from CLEAR: a handover is followed immediately by a new session's fetches, so the
    // indicators must read "not fetched yet" rather than "fetched, nothing there" — otherwise the
    // effect that gates on `!isNextPurchaseFetched` never runs for the session that just started.
    case types.RESET_RESERHUB_NEXT_PURCHASE:
      return state
        .set('nextPurchase', null)
        .set('isNextPurchaseLoading', false)
        .set('isNextPurchaseFetched', false);
    case types.SET_RESERHUB_CONNECTED_ACCOUNTS_LOADING:
      return action.isLoading
        ? state.set('isConnectedAccountsLoading', true)
        : state.set('isConnectedAccountsLoading', false).set('isConnectedAccountsFetched', true);
    case types.SET_RESERHUB_CONNECTED_ACCOUNTS:
      return state
        .set('connectedAccounts', action.connectedAccounts)
        .set('isConnectedAccountsLoading', false)
        .set('isConnectedAccountsFetched', true);
    case types.SET_RESERHUB_WALLETS_LOADING:
      return state
        .set('isWalletsLoading', action.isLoading)
        .set('isWalletsFetched', !action.isLoading);
    case types.SET_RESERHUB_WALLETS:
      return state
        .set('wallets', action.wallets)
        .set('isWalletsLoading', false)
        .set('isWalletsFetched', true);
    case types.SET_RESERHUB_DOTERS_UNAVAILABLE_DIALOG_VISIBLE:
      return state.set('showDotersUnavailableDialog', action.visible);
    default:
      return state;
  }
}
